import React from 'react'
import Product from "components/features/ThreeColWithSideImage";
import About from "components/hero/TwoColumnWithFeaturesAndTestimonial.js"

const heading = "Sutures"
const subheading = "Microvascular Anastomosis Training"
const itemCode = "itemCode"
const product = "Suture thread with needle"
const specs = ['Size 10/0', 
               '3/8 ⚫ 0.7×4 double needle', 
               '30cm black, nylon threads'
              ]
const qtt = "1 packet"

const SutureSet = () => {
    return (
        <div>
            <Product heading={heading} subheading={subheading} itemCode={itemCode} 
                     product={product} specs={specs} qtt={qtt} 
            />
            <div style={{display: 'flex',  flexDirection:'column', alignItems:'center'}}>
              <div style={{width: '50%', border: '1px solid black', borderRadius: '5px', margin: '10px'}}>
                <div style={{display: 'flex'}}>
                  <div style={{width: '25%', borderRight: '1px solid black', paddingRight: '5px', textAlign: 'center'}}>Size</div>
                  <div style={{borderRight: '1px solid black', width: '25%', paddingRight: '5px', textAlign: 'center'}}>8/0</div>
                  <div style={{borderRight: '1px solid black', width: '25%', paddingRight: '5px', textAlign: 'center'}}>9/0</div>
                  <div style={{width: '25%', paddingRight: '5px', textAlign: 'center'}}>10/0</div>
                </div>
                <div style={{display: 'flex'}}>
                  <div style={{width: '25%', borderRight: '1px solid black', paddingRight: '5px', textAlign: 'center'}}>Needle</div>
                  <div style={{width: '75%', paddingRight: '5px', textAlign: 'center', borderTop: '1px solid black'}}>3/8 ⚫ 0.7×4 double needle</div>
                </div>
                <div style={{display: 'flex'}}>
                  <div style={{width: '25%', borderRight: '1px solid black', paddingRight: '5px', textAlign: 'center'}}>Suture</div>
                  <div style={{width: '75%', paddingRight: '5px', textAlign: 'center'}}>30cm Non-Absorbable Thread</div>
                </div>
              </div>
            </div>

            <About
              heading = "About"
              description = "Perfect practice tool for Microvascular Anastomosis Training."
              imageSrc = ""
              imageDecoratorBlob = "true"
              primaryButtonUrl = "https://wa.me/60182888308?text=Hi%2C%20I%27m%20interested%20in%20buying%20Suture%20Set."
              primaryButtonText = "Buy Now"
              buttonRounded = "true"
              features2 = {["Simulation for surgeon"]}
              features3 = {["Microsurgery", "Hand surgery", "Plastic surgery", "Orthopaedic surgery"]}

              facebookUrl = "https://m.me/MedTechIns"
              whatsAppUrl = "https://wa.me/60182888308?text=Hi%2C%20I%27m%20interested%20in%20Sutures."
              emailUrl = "mailto:medicaltechinstruments@gmail.com?
                          subject=Sutures%20Enquiry
                          &body=I'm%20interested%20in%20the%20Sutures.
                         "       
            />
        </div>
    )
}

export default SutureSet
